import React from 'react'
import { Modal, Box, Typography, BoxProps } from '@mui/material'
import ButtonBase from 'design-system/button'

/**
 * ConfirmationModalProps type
 */
type ConfirmationModalProps = {
  /** Whether the modal is open */
  open: boolean
  /** The title of the modal */
  title: string
  /** Callback function for confirmation action */
  onConfirm: (event: React.MouseEvent<HTMLButtonElement>) => void
  /** Callback function for cancellation action */
  onCancel: () => void

  actionContainer?: BoxProps
}

/**
 * ConfirmationModal component
 * This component renders a modal for confirmation actions.
 * It displays a title and two buttons for confirmation and cancellation.
 *
 * @param {ConfirmationModalProps} props - The properties for the modal component.
 * @returns {JSX.Element} The rendered modal component.
 */
const ConfirmationModal: React.FC<ConfirmationModalProps> = props => {
  const { open, title, onConfirm, onCancel, actionContainer } = props

  return (
    <Modal open={open} onClose={onCancel}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 300,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          textAlign: 'center'
        }}
      >
        <Typography variant='h6' gutterBottom>
          {title}
        </Typography>
        <Box
          display='flex'
          justifyContent='end'
          flexDirection={'row-reverse'}
          gap={1}
          mt={2}
          {...actionContainer}
        >
          <ButtonBase onClick={onCancel} variant='outlined' color='warning'>
            Não
          </ButtonBase>
          <ButtonBase variant='contained' onClick={onConfirm}>
            Sim
          </ButtonBase>
        </Box>
      </Box>
    </Modal>
  )
}

export default ConfirmationModal
